<div
  class="expandable-card-container configured"
  [ngClass]="{'expandable': expandable, 'expanded': isExpanded}"
>
  <div
    class="expandable-card"
    [ngClass]="{'no-padding': noPadding, 'collapsed': !isExpanded && collapsedHeight}"
    [ngStyle]="{height: (isExpanded || !expandable || !collapsedHeight) ? '100%' : collapsedHeight}"
  >
    <ng-content></ng-content>
  </div>

  <div
    class="container-img"
    *ngIf="expandable"
  >
    <div *ngIf="isExpanded">
      Show less
    </div>
    <div *ngIf="!isExpanded">
      Show More
    </div>
    <div
      (click)="toggleCard()"
      class="expand-button"
      color="light-natural"
    >
      <mat-icon
        *ngIf="!isExpanded"
        class="icons"
      >keyboard_arrow_down</mat-icon>
      <mat-icon
        *ngIf="isExpanded"
        class="icons"
      >keyboard_arrow_up</mat-icon>

    </div>
  </div>
</div>
